import { useCallback, useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { BugReport } from '@mui/icons-material';
import { FeedbackModal } from '../feedback/FeedbackModal';

export const FeedbackFab = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  // Keyboard shortcut: Ctrl+Alt+B
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.altKey && e.key.toLowerCase() === 'b') {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <>
      <Tooltip title="Report Bug / Request Feature (Ctrl+Alt+B)" placement="right">
        <IconButton
          size="small"
          onClick={handleOpen}
          data-feedback-ignore=""
          className="print-hide"
          sx={{
            position: 'fixed',
            bottom: 12,
            left: 12,
            // Above Dialog backdrop (1300) so it stays clickable even when a dialog is open
            zIndex: 1400,
            width: 32,
            height: 32,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 1,
            opacity: 0.55,
            transition: 'opacity 0.2s ease, box-shadow 0.2s ease',
            '&:hover': {
              opacity: 1,
              boxShadow: 3,
              bgcolor: 'background.paper',
            },
          }}
        >
          <BugReport sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <FeedbackModal open={open} onClose={handleClose} />
    </>
  );
};
